import { render, staticRenderFns } from "./ResourceDialog.vue?vue&type=template&id=43026e37&scoped=true"
import script from "./ResourceDialog.vue?vue&type=script&lang=js"
export * from "./ResourceDialog.vue?vue&type=script&lang=js"
import style0 from "./ResourceDialog.vue?vue&type=style&index=0&id=43026e37&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43026e37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43026e37')) {
      api.createRecord('43026e37', component.options)
    } else {
      api.reload('43026e37', component.options)
    }
    module.hot.accept("./ResourceDialog.vue?vue&type=template&id=43026e37&scoped=true", function () {
      api.rerender('43026e37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/systemManagement/components/ResourceDialog.vue"
export default component.exports